module.exports = __webpack_public_path__ + "img/fyt_p13.afd10951.png";